<template>
  <c-main>
    <c-panel :title="competitionTitle" style="min-height: 1000px">
      <c-steps :current="currentStep" style="margin-bottom: 20px">
        <c-steps-item title="Competition settings" desc="Base data" />
        <c-steps-item title="Entrants" desc="Select user segments" />
        <c-steps-item title="Achievements" desc="Select user achievements" />
        <c-steps-item title="Content" desc="Description and media" />
        <c-steps-item title="Summary" desc="Double check" />
      </c-steps>

      <c-level>
        <c-button-group slot="center">
          <c-button
            type="primary"
            :disabled="currentStep == 1"
            iconStart="icon-arrow-left2"
            outline
            @click="changeStep('down')"
            >PREV</c-button
          >
          <c-button
            type="primary"
            :disabled="currentStep == 5"
            iconEnd="icon-arrow-right2"
            outline
            @click="changeStep('up')"
            >NEXT</c-button
          >
          <c-button
            type="success"
            iconEnd="icon-floppy-disk"
            outline
            @click="proceedSave()"
            >SAVE</c-button
          >
        </c-button-group>
      </c-level>

      <transition name="slide-fade" mode="out-in">
        <c-row v-if="currentStep == 1">
          <c-col sm="12" md="12">
            <c-divider />

            <c-row>
              <c-col>
                <c-form-field label="Status:">
                  <c-form-select
                    v-model="ac.status"
                    :options="statusOptions"
                    :disabled="ac.started"
                  />
                </c-form-field>
              </c-col>
              <c-col>
                <c-form-field label="&nbsp;">
                  <c-level>
                    <c-form-checkbox
                      label="Show"
                      slot="left"
                      v-model="ac.show"
                    ></c-form-checkbox>
                  </c-level>
                </c-form-field>
              </c-col>
              <c-col>	
                <c-form-field label="Order index">	
                  <c-form-input	
                    v-model="ac.order_index"	
                  ></c-form-input>	
                </c-form-field>	
              </c-col>
            </c-row>

            <c-row>	
              <c-col>	
                <c-form-field label="Name:*">	
                  <c-form-input	
                    v-model="ac.name"	
                    v-bind:status="$v.ac.name.$error ? 'danger' : ''"	
                  ></c-form-input>	
                  <span v-if="!$v.ac.name.required" class="form-help u-color-danger"	
                    >Name is required.</span	
                  >	
                </c-form-field>	
              </c-col>	
              <c-col>	
                <c-form-field label="Type:">	
                  <c-form-select	
                    v-model="ac.custom_type"	
                    :options="customTypeOptions"	
                    :disabled="ac.started"	
                  />	
                </c-form-field>	
              </c-col>	
            </c-row>

            <c-divider />

            <c-row>
              <c-col>
                <c-form-field label="Date From:">
                  <c-flatpickr
                    v-model="ac.start_date"
                    :disabled="ac.started"
                    with-time
                    format="Y-m-d H:i"
                  />
                </c-form-field>
              </c-col>
              <c-col>
                <c-form-field label="Date To:">
                  <c-flatpickr
                    v-model="ac.end_date"
                    with-time
                    format="Y-m-d H:i"
                  />
                </c-form-field>
              </c-col>
            </c-row>

            <c-divider />

            <c-form-field label="Groups:">
              <c-multiselect
                v-model="ac.groups"
                track-by="value"
                label="key"
                :options="groups"
                :taggable="false"
                placeholder="Search for group"
                :multiple="true"
              ></c-multiselect>
            </c-form-field>


            <c-form-field label="Week Days:">
              <c-nav type="pills">
                <c-nav-item :title="week.key" :active="isWkDayActive(week.value)" v-for="week in wkDays" :key="week.value" @click="changeWkDays(week.value)"></c-nav-item>
              </c-nav>
            </c-form-field>  
      

          </c-col>

          <c-col>
            <c-divider />
            <c-form-field label="Description:">
              <c-form-textarea v-model="ac.description_text" rows="20" />
            </c-form-field>
          </c-col>
        </c-row>
      </transition>

      <transition name="slide-fade" mode="out-in">
        <c-row v-if="currentStep == 2">	
          <c-col>	
            <c-row>	
              <c-col sm="18" md="18">	
                <c-divider />	
                <c-form-field label="User segments (keep empty for all):">	
                  <c-multiselect	
                    v-model="ac.segments"	
                    :loading="isLoading"	
                    track-by="id"	
                    label="name"	
                    :options="segments"	
                    :searchable="true"	
                    :internal-search="false"	
                    :close-on-select="false"	
                    :clear-on-select="true"	
                    :limit="50"	
                    @search-change="asyncUserSegmentSearch"	
                    placeholder="Type to search user segments"	
                    :multiple="true"	
                  >	
                    <span slot="noResult">Oops! No segments found.</span>	
                    <template slot="option" slot-scope="props">	
                      <article class="cell">	
                        <div	
                          class="cell__content"	
                          v-text="'[' + props.option.id + '] ' + props.option.name"	
                        ></div>	
                      </article>	
                    </template>	
                  </c-multiselect>	
                </c-form-field>	
              </c-col>	
            </c-row>	
            <c-row v-for="additional_field in additional_fields" :key="additional_field._id">	
              <c-col>	
                <c-divider />	
                {{additional_field.key}}	
                <c-multiselect	
                  v-model="addFields[additional_field.value]"	
                  track-by="value"	
                  label="label"	
                  :options="additionalFieldsOptions"	
                  :taggable="true"	
                  placeholder="Add a new value"	
                  @tag="addAdditionalField($event, additional_field.value)"	
                  :multiple="true">	
                </c-multiselect>	
              </c-col>	
            </c-row>	
          </c-col>	
        </c-row>
      </transition>

      <transition name="slide-fade" mode="out-in">
        <c-row v-if="currentStep == 3">
          <c-col sm="12" md="12">
              <c-divider />
              <c-box title="Available Achievements">
                <c-form-field label="Search Achievement">
                  <c-form-input
                    v-model="search_achievement"
                  ></c-form-input>
                </c-form-field>

                  <c-scroll-view style="height:400px;">
                      <draggable class="list list--bordered" :list="filteredAchievements" group="achievements" :sort="false">
                        <div
                          class="list__item"
                          v-for="(element, index) in filteredAchievements"
                          :key="element.value"
                        >
                          {{ element.label }}
                        </div>
                      </draggable>
                  </c-scroll-view>
              </c-box>
          </c-col>

          <c-col>
              <c-divider />
              <c-box title="Assigned achievements">
                  <c-scroll-view style="height:400px;">
                      <draggable class="list list--bordered" :list="ac.achievements" group="achievements">
                        <div
                          class="list__item"
                          v-for="(element, index) in ac.achievements"
                          :key="element.value"
                        >
                          {{ element.label }}
                          <i class="icon-menu2" style="float: right;"></i>
                        </div>
                      </draggable>
                  </c-scroll-view>
              </c-box>
          </c-col>          
        </c-row>
      </transition>

      <transition name="slide-fade" mode="out-in">
        <c-row v-if="currentStep == 4">
          <c-col>
            <c-divider />

            <c-tabs type="underline" size="lg">
              <c-tabs-pane
                :label="language.lang_desc"
                :name="language.lang_code"
                v-for="language in languages"
                v-bind:key="language.lang_code"
              >
                <c-row>
                  <c-col>
                    <c-form-field label="Title:">
                      <c-form-input
                        v-model="ac.description[language.lang_code].title"
                      ></c-form-input>
                    </c-form-field>
                  </c-col>
                  <c-col>
                    <c-form-field label="Tagline:">
                      <c-form-input
                        v-model="ac.description[language.lang_code].tagline"
                      ></c-form-input>
                    </c-form-field>
                  </c-col>
                  <c-col>
                    <c-form-field label="Medium title:">
                      <c-form-input
                        v-model="ac.description[language.lang_code].mediumtitle"
                      ></c-form-input>
                    </c-form-field>
                  </c-col>
                </c-row>

                <c-row>
                  <c-col>
                    <c-form-field label="Reward Title:">
                      <c-form-input
                        v-model="ac.description[language.lang_code].reward_title"
                      ></c-form-input>
                    </c-form-field>
                  </c-col>
                  <c-col>
                    <c-form-field label="Reward Tagline:">
                      <c-form-input
                        v-model="ac.description[language.lang_code].reward_tagline"
                      ></c-form-input>
                    </c-form-field>
                  </c-col>
                  <c-col>
                    <c-form-field label="Reward Medium title:">
                      <c-form-input
                        v-model="ac.description[language.lang_code].reward_mediumtitle"
                      ></c-form-input>
                    </c-form-field>
                  </c-col>
                </c-row>

                <c-row>
                  <c-col>
                    <c-form-field label="Condition Title:">
                      <c-form-input
                        v-model="ac.description[language.lang_code].condition_title"
                      ></c-form-input>
                    </c-form-field>
                  </c-col>
                  <c-col>
                    <c-form-field label="Condition Tagline:">
                      <c-form-input
                        v-model="ac.description[language.lang_code].condition_tagline"
                      ></c-form-input>
                    </c-form-field>
                  </c-col>
                  <c-col>
                    <c-form-field label="Condition Medium title:">
                      <c-form-input
                        v-model="ac.description[language.lang_code].condition_mediumtitle"
                      ></c-form-input>
                    </c-form-field>
                  </c-col>
                </c-row>

                <c-row>
                  <c-col>
                    <c-form-field label="URL Info:">
                      <c-form-input
                        v-model="ac.description[language.lang_code].url_info"
                      ></c-form-input>
                    </c-form-field>
                  </c-col>
                  <c-col>
                    <c-form-field label="URL 1:">
                      <c-form-input
                        v-model="ac.description[language.lang_code].url1"
                      ></c-form-input>
                    </c-form-field>
                  </c-col>
                  <c-col>
                    <c-form-field label="URL 2:">
                      <c-form-input
                        v-model="ac.description[language.lang_code].url2"
                      ></c-form-input>
                    </c-form-field>
                  </c-col>
                </c-row>

                <c-row>
                  <c-col>
                    <c-form-field label="Small Description:">
                      <c-form-textarea
                        v-model="
                          ac.description[language.lang_code].small_description
                        "
                        rows="8"
                      />
                    </c-form-field>
                  </c-col>
                  <c-col>
                    <c-form-field label="Description:">
                      <c-form-textarea
                        v-model="
                          ac.description[language.lang_code].description
                        "
                        rows="8"
                      />
                    </c-form-field>
                  </c-col>
                </c-row>

                <c-row>
                  <c-col>
                    <c-form-field label="Desktop Image 1:">
                      <file-pond
                        name="desktop_image1"
                        label-idle="Drop files here..."
                        v-bind:allow-multiple="false"
                        accepted-file-types="image/jpeg, image/png, image/svg+xml"
                        v-bind:server="{
                          url:
                            $cfg.API_URL +
                            '/upload/achievement-media/desktop_image/1',
                          process: {
                            headers: {
                              'x-image-id':
                                'files.' + language.lang_code + '.desktop_image1',
                            },
                          },
                        }"
                        @processfile="handleFileUpload"
                      />
                    </c-form-field>
                    <img
                      v-if="
                        ac.files[language.lang_code] &&
                        ac.files[language.lang_code].desktop_image1
                      "
                      class="image-preview"
                      :src="`${$cfg.IMAGE_URL}/${
                        ac.files[language.lang_code].desktop_image1
                      }`"
                      alt
                    />

                    <c-form-field label="Desktop Image 2:">
                      <file-pond
                        name="desktop_image2"
                        label-idle="Drop files here..."
                        v-bind:allow-multiple="false"
                        accepted-file-types="image/jpeg, image/png, image/svg+xml"
                        v-bind:server="{
                          url:
                            $cfg.API_URL +
                            '/upload/achievement-media/desktop_image/2',
                          process: {
                            headers: {
                              'x-image-id':
                                'files.' + language.lang_code + '.desktop_image2',
                            },
                          },
                        }"
                        @processfile="handleFileUpload"
                      />
                    </c-form-field>
                    <img
                      v-if="
                        ac.files[language.lang_code] &&
                        ac.files[language.lang_code].desktop_image2
                      "
                      class="image-preview"
                      :src="`${$cfg.IMAGE_URL}/${
                        ac.files[language.lang_code].desktop_image2
                      }`"
                      alt
                    />

                    <c-form-field label="Desktop Image 3:">
                      <file-pond
                        name="desktop_image3"
                        label-idle="Drop files here..."
                        v-bind:allow-multiple="false"
                        accepted-file-types="image/jpeg, image/png, image/svg+xml"
                        v-bind:server="{
                          url:
                            $cfg.API_URL +
                            '/upload/achievement-media/desktop_image3',
                          process: {
                            headers: {
                              'x-image-id':
                                'files.' + language.lang_code + '.desktop_image3',
                            },
                          },
                        }"
                        @processfile="handleFileUpload"
                      />
                    </c-form-field>
                    <img
                      v-if="
                        ac.files[language.lang_code] &&
                        ac.files[language.lang_code].desktop_image3
                      "
                      class="image-preview"
                      :src="`${$cfg.IMAGE_URL}/${
                        ac.files[language.lang_code].desktop_image3
                      }`"
                      alt
                    />
                  </c-col>
                  <c-col>
                    <c-form-field label="Mobile Image 1:">
                      <file-pond
                        name="mobile_image1"
                        label-idle="Drop files here..."
                        v-bind:allow-multiple="false"
                        accepted-file-types="image/jpeg, image/png, image/svg+xml"
                        v-bind:server="{
                          url:
                            $cfg.API_URL +
                            '/upload/achievement-media/mobile_image/1',
                          process: {
                            headers: {
                              'x-image-id':
                                'files.' + language.lang_code + '.mobile_image1',
                            },
                          },
                        }"
                        @processfile="handleFileUpload"
                      />
                    </c-form-field>
                    <img
                      v-if="
                        ac.files[language.lang_code] &&
                        ac.files[language.lang_code].mobile_image1
                      "
                      class="image-preview"
                      :src="`${$cfg.IMAGE_URL}/${
                        ac.files[language.lang_code].mobile_image1
                      }`"
                      alt
                    />

                    <c-form-field label="Mobile Image 2:">
                      <file-pond
                        name="mobile_image2"
                        label-idle="Drop files here..."
                        v-bind:allow-multiple="false"
                        accepted-file-types="image/jpeg, image/png, image/svg+xml"
                        v-bind:server="{
                          url:
                            $cfg.API_URL +
                            '/upload/achievement-media/mobile_image/2',
                          process: {
                            headers: {
                              'x-image-id':
                                'files.' + language.lang_code + '.mobile_image2',
                            },
                          },
                        }"
                        @processfile="handleFileUpload"
                      />
                    </c-form-field>
                    <img
                      v-if="
                        ac.files[language.lang_code] &&
                        ac.files[language.lang_code].mobile_image2
                      "
                      class="image-preview"
                      :src="`${$cfg.IMAGE_URL}/${
                        ac.files[language.lang_code].mobile_image2
                      }`"
                      alt
                    />

                    <c-form-field label="Mobile Image 3:">
                      <file-pond
                        name="mobile_image3"
                        label-idle="Drop files here..."
                        v-bind:allow-multiple="false"
                        accepted-file-types="image/jpeg, image/png, image/svg+xml"
                        v-bind:server="{
                          url:
                            $cfg.API_URL +
                            '/upload/achievement-media/mobile_image/3',
                          process: {
                            headers: {
                              'x-image-id':
                                'files.' + language.lang_code + '.mobile_image3',
                            },
                          },
                        }"
                        @processfile="handleFileUpload"
                      />
                    </c-form-field>
                    <img
                      v-if="
                        ac.files[language.lang_code] &&
                        ac.files[language.lang_code].mobile_image3
                      "
                      class="image-preview"
                      :src="`${$cfg.IMAGE_URL}/${
                        ac.files[language.lang_code].mobile_image3
                      }`"
                      alt
                    />
                  </c-col>
                </c-row>
              </c-tabs-pane>
            </c-tabs>
          </c-col>
        </c-row>
      </transition>

      <transition name="slide-fade" mode="out-in">
        <c-row v-if="currentStep == 5">
          <c-col sm="24" md="24">
            <c-divider />
            <c-box title="Settings">
              <c-row>
                <c-col xs="4" sm="4" md="4" lg="4" xl="4">Show:</c-col>
                <c-col xs="20" sm="20" md="20" lg="20" xl="20">{{
                  ac.show
                }}</c-col>
                <c-col xs="4" sm="4" md="4" lg="4" xl="4">Status:</c-col>
                <c-col xs="20" sm="20" md="20" lg="20" xl="20">{{
                  ac.status
                }}</c-col>
                <c-col xs="4" sm="4" md="4" lg="4" xl="4">Name:</c-col>
                <c-col xs="20" sm="20" md="20" lg="20" xl="20">{{
                  ac.name
                }}</c-col>
                <c-col xs="4" sm="4" md="4" lg="4" xl="4">Date range:</c-col>
                <c-col xs="20" sm="20" md="20" lg="20" xl="20"
                  >{{ formatDateTime(ac.start_date) }} -
                  {{ formatDateTime(ac.end_date) }}</c-col
                >                
                <c-col xs="4" sm="4" md="4" lg="4" xl="4">Groups:</c-col>
                <c-col
                  xs="20"
                  sm="20"
                  md="20"
                  lg="20"
                  xl="20"
                  v-if="ac.groups != null && ac.groups.length > 0"
                >
                  <div v-for="group in ac.groups" :key="group.value">
                    {{ group.key }}
                  </div>
                </c-col>
                <c-col v-else xs="20" sm="20" md="20" lg="20" xl="20"
                  >No groups</c-col
                >

                <c-col xs="4" sm="4" md="4" lg="4" xl="4">Description:</c-col>
                <c-col xs="20" sm="20" md="20" lg="20" xl="20">{{
                  ac.description_text
                }}</c-col>
              </c-row>
            </c-box>

            <c-box title="Entrants">
              <c-row>
                <c-col xs="4" sm="4" md="4" lg="4" xl="4">User segments:</c-col>
                <c-col
                  xs="20"
                  sm="20"
                  md="20"
                  lg="20"
                  xl="20"
                  v-if="ac.segments != null && ac.segments.length > 0"
                >
                  <div v-for="segment in ac.segments" :key="segment.id">
                    [{{ segment.id }}] {{ segment.name }}
                  </div>
                </c-col>
                <c-col v-else xs="20" sm="20" md="20" lg="20" xl="20"
                  >ALL</c-col
                >
              </c-row>
            </c-box>

            <c-box title="Achievements">
              <c-row>
                <c-col xs="4" sm="4" md="4" lg="4" xl="4">Assigned achievements:</c-col>
                <c-col
                  xs="20"
                  sm="20"
                  md="20"
                  lg="20"
                  xl="20"
                  v-if="ac.achievements != null && ac.achievements.length > 0"
                >
                  <div v-for="achievement in ac.achievements" :key="achievement.id">
                    {{ achievement.label }}
                  </div>
                </c-col>
                <c-col v-else xs="20" sm="20" md="20" lg="20" xl="20"
                  >ALL</c-col
                >
              </c-row>
            </c-box>

          </c-col>
        </c-row>
      </transition>
    </c-panel>
  </c-main>
</template>
<script>
import FlatPickr from "cover/vendors/flatpickr";
import Multiselect from "cover/vendors/multiselect";
import { required } from "vuelidate/lib/validators";
import moment from "moment";

import vueFilePond from "vue-filepond";
import "filepond/dist/filepond.min.css";
import "filepond-plugin-image-preview/dist/filepond-plugin-image-preview.min.css";
import FilePondPluginFileValidateType from "filepond-plugin-file-validate-type";
import FilePondPluginImagePreview from "filepond-plugin-image-preview";

import draggable from "vuedraggable";

// Create component
const FilePond = vueFilePond(
  FilePondPluginFileValidateType,
  FilePondPluginImagePreview
);
import config from "../../../../config";
import { mapState } from "vuex";

export default {
  name: "Achievement",
  components: {
    [FlatPickr.name]: FlatPickr,
    "c-multiselect": Multiselect,
    FilePond,
    draggable
  },

  validations: {
    ac: {
      name: { required },
    },
  },

  data() {
    let description = {};
    let files = {};
    for (var language of this.$store.state.languages) {
      description[language.lang_code] = {};
      files[language.lang_code] = {};
    }

    let addFields = {};	
    for (var af of this.$store.state.additional_fields) {	
      addFields[af.value] = [];	
    }

    return {
      currentStep: 1,
      //Multiselect options
      asyncSelected: [],
      isLoading: false,
      search_achievement: '',
      achievements: [],
      segments: [],
      addFields: addFields,
//       filteredAchievements: [],

      ac: {
        name: "",
        order_index: 0,
        start_date: "",
        end_date: "",
        description_text: "",
        status: "draft",
        custom_type: "regular",
        show: true,
        achievements: [],
        segments: [],
        groups: [],
        files: files,
        description: description,
        active_wk_days: [],
        additional_fields: {},
      },
      statusOptions: [
        { value: "draft", label: "Draft" },
        { value: "enabled", label: "Enabled" }
      ],
      customTypeOptions: [	
        { value: "regular", label: "Regular" },	
        { value: "first_deposit", label: "First Deposit" },	
        { value: "phone_verification", label: "Phone Verification" },	
        { value: "email_verification", label: "Email Verification" }	
      ],	
      additionalFieldsOptions: [],
    };
  },
  computed: {
    filteredAchievements() {
      return this.achievements.filter( _ =>
        _.label.toLowerCase().includes( this.search_achievement.toLowerCase() ) &&
        this.ac.achievements.filter( q => _.value === q.value ).length === 0
      )
    },
    competitionTitle() {
      return this.ac && this.ac._id
        ? "Competition: " + this.ac.name
        : "Create new competition";
    },    
    ...mapState(["languages", "groups", "wkDays", "additional_fields"]),
    isWkDayActive() {
      return wk => (this.ac.active_wk_days.length == 0 || this.ac.active_wk_days.indexOf(parseInt(wk)) > -1)
    }
  },
  methods: {
    addAdditionalField(str, key) {	
      const tag = {	
        value: str,	
        label: str	
      }      	
      this.addFields[key].push(tag)      	
    },
    formatDateTime(date) {
      return date ? moment(date).format("YYYY-MM-DD HH:mm") : "Not set";
    },
    changeWkDays: function(wk) {
      if(!this.ac.active_wk_days || this.ac.active_wk_days.length == 0) {
        this.ac.active_wk_days = [1,2,3,4,5,6,7];
      }
      let idx = this.ac.active_wk_days.indexOf(parseInt(wk));
      if(idx === -1) {
        this.ac.active_wk_days.push(parseInt(wk));
      } else {
        this.ac.active_wk_days.splice(idx, 1);
      }
    },
    proceedSave: function () {
      var _this = this;
      const vm = this.$toast.loading("Saving...");

      if(this.addFields) {	
        for(let f in this.addFields) {	
          _this.ac.additional_fields[f] = [];	
          for(let a of this.addFields[f]) {	
            _this.ac.additional_fields[f].push(a.value);	
          }	
        }	
      }

      var postData = {
        ac: _this.ac,
        cd: _this.conditionsData,
      };

      if (this.$route.params.id) {
        postData._id = this.$route.params.id;
        var postUrl = _this.$cfg.API_URL + "/competitions/update-competition";
      } else {
        var postUrl = _this.$cfg.API_URL + "/competitions/save-competition";
      }

      this.$axios
        .post(postUrl, postData)
        .then((res) => {
          if (res.data.status == "ok") {
            this.$notify({
              type: "success",
              title: "Competition Saved",
              closeable: true,
              duration: 5000,
            });
            vm.hide();
            this.$router.push("/secure/competitions/list");
          }
        })
        .catch((err) => {
          this.$notify({
            type: "danger",
            title: "Server error",
            content:
              err.response && err.response.data
                ? err.response.data.error
                : "Unable to save competition",
            closeable: true,
            duration: 5000,
          });
          vm.hide();
        });
    },
    changeStep: function (way) {
      if (way == "up") {
        if (this.currentStep >= 5) return;

        if (this.currentStep == 1) {
          this.$v.ac.$touch();
          if (this.$v.ac.$pending || this.$v.ac.$error) return;
        }

        this.currentStep++;
      }
      if (way == "down") {
        if (this.currentStep <= 1) return;
        this.currentStep--;
      }
    },

    asyncUserSegmentSearch(query) {
      this.isLoading = true;
      this.$axios(
        config.API_URL +
        "/user-segments/get-segments?q=" +
        encodeURIComponent(query)
      )
        .then((res) => {
          if (res.status == 200) {
            return res.data;
          } else {
            return Promise.reject();
          }
        })
        .then((data) => {
          this.segments = data.data.length ? data.data : [];
          this.isLoading = false;
        })
        .catch((err) => {
          this.isLoading = false;
        });
    },

    handleFileUpload(error, file) {
      let handleData = file.serverId.split("|");
      eval("this.ac." + handleData[1] + "='" + handleData[0] + "'");
    },
  },
  created() {
    const _this = this;

    this.asyncUserSegmentSearch(""); //trigger to show full list of segments

    //Get achievements data
    this.$axios
      .get(_this.$cfg.API_URL + "/settings/achievements")
      .then((response) => {
        let achievements = response.data.data;

        _this.achievements = achievements.map( _ =>
            new Object({
              value: _._id.toString(),
              label: _.name
            })
        )        
        
        //lets check if any archived ach8ivement
        if(_this.ac.achievements && _this.ac.achievements.length) {
          for (let achiv of _this.ac.achievements) {                  
              let found = _this.achievements.filter(a => a.value == achiv.value);
              console.log(achiv.value, found)
              if(found && found.length) {
                achiv.label = found[0].label;
              } else {
                achiv.label = '[ARCHIEVED] ' + achiv.label
              }                        
          }
        }

        console.log(this.ac)

        _this.filteredAchievements = _this.achievements
      })
      .catch((err) => { console.error( err ) });

    if (this.$route.params.id) {
      this.$axios
        .post(_this.$cfg.API_URL + "/competitions/get-competition-by-id/", {
          _id: this.$route.params.id,
        })
        .then((response) => {
          if (response.status == 200) {
            //!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
            _this.ac = Object.assign(_this.ac, response.data.data[0]);
            _this.conditionsData = response.data.data[0].conditions;
            //_this.currentStep = _this.ac.started ? 6 : 1;
            _this.currentStep = 1;

            for (var language of _this.$store.state.languages)
              if (!_this.ac.description[language.lang_code])
                _this.ac.description[language.lang_code] = {};
            if (!_this.ac.files[language.lang_code])
              _this.ac.files[language.lang_code] = {};

            if(_this.ac.additional_fields) {	
              for (var af of _this.$store.state.additional_fields) {               	
                _this.addFields[af.value] = []; 	
                if (_this.ac.additional_fields[af.value])	
                  for (var f of _this.ac.additional_fields[af.value])	
                    _this.addAdditionalField(f, af.value)                      	
              } 	
            }
          }
        })
        .catch((err) => { });
    }
  },
};
</script>

<style scoped>
@import "~cover/vendors/multiselect/style.css";
@import "~cover/vendors/quill-editor/style.css";
.image-preview {
  width: 100%;
  border-radius: 20px;
}
</style>
